import { createReducer } from '@reduxjs/toolkit'
import Bowser from 'bowser'

import { receivedMarket, setApiError } from '../../actions/actions'

const initialState = {
  breadcrumbs: [],
  errors: [],
  type: Bowser.getParser(window.navigator.userAgent).getPlatformType()
}

const website = createReducer(initialState, {
  [receivedMarket]: (state, { payload: marketProps }) => ({ ...state, ...marketProps }),
  [setApiError]: (state, { payload: error }) => {
    state.errors.push(error)
  }
})

export default website
